<template>
  <div>
    <div class="row">
      <span class="font-weight-bold">
        Éves km futás
      </span>
      <span class="font-weight-light">
        (ezer km)
      </span>
    </div>
    <div class="row mb-2">
      <div
        v-for="each of annualMileages"
        :key="'annual_mileage' + each"
        class="col"
      >
        <button
          type="button"
          :class="{'btn-light': each !== annualMileage, 'btn-primary': each === annualMileage }"
          class="btn btn-square btn-sm btn-block"
          @click="setAnnualMileage(each)"
        >
          {{ each }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue';
  import {Component, Prop} from 'vue-property-decorator';
  import { namespace } from 'vuex-class';

  const configuratorModule = namespace('configurator');

  @Component
  export default class AnnualMileagesSelector extends Vue {
    @configuratorModule.Getter('getAnnualMileages') annualMileages;
    @configuratorModule.Getter('getAnnualMileage') annualMileage;
    @configuratorModule.Mutation('setAnnualMileage') setAnnualMileage;

    @Prop(Object) lead;

    price_filter = null;

    created() {
      if (!this.lead) {
        this.price_filter = JSON.parse(localStorage.getItem('filter'));
        if (this.price_filter) {
          this.setAnnualMileage(parseInt(this.price_filter.annualMileage));
        }
      }
    }
  }
</script>
